import { Menu } from 'antd';
import { AsumsiIcon } from 'asumsi-components';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export const MenuSidebarComponent = () => {
  const [selectedKey, setSelectedKey] = useState(['']);
  const [openKeys, setOpenKeys] = useState(['']);

  const onClickMenu = (key: string) => {
    const arrKey: any[] = [];
    arrKey.push(key);
    setSelectedKey(arrKey);
  };

  const setMenuActive = () => {
    const pathname: string = location.pathname;
    let clicked = pathname.replace("/", "");
    const origin = pathname.split("/");
    if (origin.length > 2) {
      const openKeys: string[] = [];
      for (let index = 1; index < origin.length - 1; index++) {
        if (index == 1) {
          openKeys.push(`/${origin[index]}`);
        } else {
          let child: string = "";
          for (let indexChild = 1; indexChild <= index; indexChild++) {
            child = `${child}/${origin[indexChild]}`;
          }
          openKeys.push(child)
        }
      }
      setOpenKeys(openKeys);
    }

    clicked = pathname;

    if (origin.length > 1 && origin[2] == 'form') {
      clicked = `/${origin[1]}`;
    } else if (origin.length > 3 && origin[3] == 'form') {
      clicked = `/${origin[1]}/${origin[2]}`;
    }

    onClickMenu(clicked);
  };

  const openChange = (e: any) => {
    setOpenKeys(e);
  }

  useEffect(() => {
    setMenuActive();
  }, []);


  const menus: any = [
    {
      "id": "1",
      "name": "Dashboard",
      "parent": null,
      "url": "/dashboard",
      "icon": "chart",
      "children": null
    },
    {
      "id": "2",
      "name": "Article",
      "parent": null,
      "url": "/article",
      "icon": "book",
      "children": [
        {
          "id": "3",
          "name": "Topic",
          "parent": "2",
          "url": "/article/topics",
          "icon": "tag",
          "children": null
        },
        {
          "id": "4",
          "name": "Posts",
          "parent": "2",
          "url": "/article/posts",
          "icon": "book",
          "children": null
        },
        // {
        //   "id": "5",
        //   "name": "Landing Page",
        //   "parent": "2",
        //   "url": "/article/landing-page",
        //   "icon": "page-layout",
        //   "children": null
        // },
        // {
        //   "id": "6",
        //   "name": "News Crawler",
        //   "parent": "2",
        //   "url": "/article/news-crawler",
        //   "icon": "layers",
        //   "children": null
        // },
        {
          "id": "15",
          "name": "Videos",
          "parent": "2",
          "url": "/article/videos",
          "icon": "video",
          "children": null
        }
      ]
    },
    {
      "id": "7",
      "name": "Settings",
      "parent": null,
      "url": "/settings",
      "icon": "cog",
      "children": [
        {
          "id": "8",
          "name": "Home Page",
          "parent": "7",
          "url": "/settings/home-page",
          "icon": "home",
          "children": null
        },
        {
          "id": "9",
          "name": "Statics",
          "parent": "7",
          "url": "/settings/statics",
          "icon": "panel-stats",
          "children": null
        },
        {
          "id": "10",
          "name": "Footer",
          "parent": "7",
          "url": "/settings/footer",
          "icon": "widget-footer",
          "children": null
        },
        // {
        //   "id": "11",
        //   "name": "Dashboard",
        //   "parent": "7",
        //   "url": "/settings/dashboard",
        //   "icon": "chart",
        //   "children": null
        // }
      ]
    },
    {
      "id": "11",
      "name": "User",
      "parent": null,
      "url": "/user",
      "icon": "people",
      "children": [
        {
          "id": "12",
          "name": "Roles",
          "parent": "11",
          "url": "/user/roles",
          "icon": "control",
          "children": null
        },
        {
          "id": "13",
          "name": "Role Groups",
          "parent": "11",
          "url": "/user/role-groups",
          "icon": "group-objects",
          "children": null
        },
        {
          "id": "14",
          "name": "User",
          "parent": "11",
          "url": "/user/users",
          "icon": "people",
          "children": null
        }
      ]
    }
  ];


  const getDataParent = (listMenu: any[], id: string) => {
    let parent = null;
    listMenu.forEach((f: any) => {
      if (f.id == id) {
        parent = f;
      } else if (f.children && f.children.length > 0) {
        const child = getDataParent(f.children, id);
        if (child) {
          parent = child;
        }
      }
    });
    return parent;
  }

  const generateChild = (dtChilds: any[]) => {
    return dtChilds.map((dt: any) => {
      if (dt.children && dt.children.length > 0) {
        return <Menu.SubMenu key={dt.url} title={
          <div>
            <AsumsiIcon icon={dt.icon} />
            <span className="nav-text">{dt.name}</span>
          </div>}
        >
          {generateChild(dt.children)}
        </Menu.SubMenu>
      }

      return <Menu.Item key={dt.url}>
        <Link to={dt.url}>
          <AsumsiIcon icon={dt.icon} />
          <span className="nav-text">{dt.name}</span>
        </Link>
      </Menu.Item>
    })
  }

  const generateMenus = () => {
    return generateChild(menus);
  };

  return <Menu
    mode="inline"
    theme="dark"
    style={{
      height: "calc(100vh - 110px)",
      overflow: "auto",
    }}
    selectedKeys={selectedKey}
    defaultSelectedKeys={['/dashboard']}
    // tslint:disable-next-line:jsx-no-lambda
    onClick={(e: any) => onClickMenu(e.key)}
    openKeys={openKeys}
    onOpenChange={openChange}
  >
    {generateMenus()}
  </Menu>;
};

export default MenuSidebarComponent;



// WEBPACK FOOTER //
// ./src/components/organisms/menu-sidebar/component.tsx